import {LOAD_WORK_ORDER_SUCCESS, SET_APPLICATION_FLAGS, SET_VERSION_MISMATCH_FLAG, CLEAR_VERSION_MISMATCH_FLAG} from "../actions/dispatchTypes";
import {APP_VERSION} from "../config/env";

const defaultState = {
    webVersion: APP_VERSION,
    versionMismatch: false
};

export default function appFlagsReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_APPLICATION_FLAGS:
            return action.payload || state;
        case SET_VERSION_MISMATCH_FLAG:
            return {
                ...state,
                versionMismatch: true
            };
        case CLEAR_VERSION_MISMATCH_FLAG:
            return {
                ...state,
                versionMismatch: false
            };
        case LOAD_WORK_ORDER_SUCCESS:
            console.log("LOAD_WORK_ORDER_SUCCESS", action.payload);
            if (action.payload && action.payload.appFlags) {
                return {
                    ...state,
                    flags: {
                        ...state?.flags,
                        ...action.payload.appFlags
                    }
                };
            }
            return state;
        default:
            return state;
    }
}

